module.exports = __webpack_public_path__ + "static/img/icon16.61244ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon16.png
// module id = kPam
// module chunks = 1